import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function NewTag(props: { className?: string }) {
  return (
    <span
      className={twMerge(
        'px-1 mr-1 text-xs font-semibold text-white bg-blue-700 rounded uppercase',
        props.className
      )}
    >
      NEW
    </span>
  );
}
